const debounce = (fn, delay) => {
  let timeout;
  return function (e) {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      fn(e);
    }, delay);
  };
};

export default debounce;
